import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/weadapt-users');

const trackingService = createService(httpClient, (client) => ({
    registerLogin(data) {
        if (data.bynderUserId) {
            return client.post('/register/login', data);
        }

        return null;
    },
}));

export default trackingService;
